/* eslint-disable */
import React, {
  useMemo, useRef, useState
} from 'react';
import { UseFormReturn } from 'react-hook-form';
import SignatureCanvas from 'react-signature-canvas';
import {
  Image, Loading, Typography
} from 'tfc-components';

import bgConfirm from 'assets/images/bg-confirm-remake.jpg';
import buttonEmpty from 'assets/images/button_empty.png';
import hoanthanh from 'assets/images/hoanthanh.png';
import kyLai from 'assets/images/KY_LAI.png';
import Icon from 'components/atoms/Icon';
import { UserInfoType } from 'pages/UserInfo';
import { CheckinParams } from 'services/checkin/types';
import { useAppSelector } from 'store/hooks';
import mapModifiers, {
  formatDDMMYYYY,
  imageLoader, wrapText
} from 'utils/functions';

type ConfirmProps = {
  checkinMethod: UseFormReturn<UserInfoType>;
  handleSubmit: (data: CheckinParams) => void;
  isCheckin?: boolean;
  loading?: boolean;
};

const WIDTH = 1600;
const HEIGHT = 2134;
const TEXT_SIZE = 29;
const TEXT_SIZE_NAME = 40;
const TEXT_COLOR = '#fff';

const Confirm: React.FC<ConfirmProps> = ({
  handleSubmit, checkinMethod, isCheckin, loading
}) => {
  const [signature, setSignature] = useState<SignatureCanvas>();
  const [url, setUrl] = useState<string>('');
  const [confirmJoin, setConfirmJoin] = useState<boolean>(true);
  const [firstTime, setFirstTime] = useState<boolean>(false);
  const [isSigned, setIsSigned] = useState<boolean>(false);
  const campaign = useAppSelector((state) => state.system.campaignData);

  const backgroundRef = useRef<HTMLImageElement | null>(null);
  const canvas = useMemo(() => {
    const c = document.createElement('canvas');
    c.width = WIDTH;
    c.height = HEIGHT;

    return c;
  }, []);

  const ctx = useMemo(() => canvas.getContext('2d')!, [canvas]);

  const draw = async () => {
    if (!campaign) {
      return;
    }
    if (!backgroundRef.current) {
      const bg = await imageLoader(bgConfirm);
      backgroundRef.current = bg;
      ctx.drawImage(bg, 0, 0, WIDTH, HEIGHT);
    } else {
      ctx.drawImage(backgroundRef.current, 0, 0, WIDTH, HEIGHT);
    }

    ctx.font = `bold ${TEXT_SIZE}px 'Open Sans', sans-serif`;

    ctx.fillStyle = TEXT_COLOR;
    const title = campaign?.seminarTitle?.split('<br />') || [];
    title.forEach((item: string, index: number) => {
      const textWidth = ctx.measureText(item).width;
      ctx.fillText(item.toUpperCase(), WIDTH / 2 - textWidth / 2, 490 + index * 50);
    });

    /// /// Draw time and location
    const timeText = `Thời gian: ${campaign?.startAt || ''}`;
    const locationText = `Địa điểm: ${campaign?.address?.toUpperCase() || ''}`;
    ctx.fillText(timeText, WIDTH / 2 - (ctx.measureText(timeText).width) / 2, 660);
    ctx.fillText(locationText, WIDTH / 2 - (ctx.measureText(locationText).width) / 2, 715);

    ctx.font = `bold ${TEXT_SIZE_NAME}px 'Open Sans', sans-serif`;

    const { full_name, hospital } = checkinMethod.getValues();
    const province = checkinMethod.getValues('provinceCode.label') as string || '';

    ctx.fillText((full_name || '').toUpperCase(), 460, 802);
    const wrappedText = wrapText(ctx, (hospital || '').toUpperCase(), 462, 865, WIDTH - 630, 56);
    wrappedText.forEach((item: (string | number)[]) => {
      ctx.fillText(String(item[0]), Number(item[1]), Number(item[2]));
    });
    ctx.fillText(`TỈNH THÀNH: ${province.toUpperCase() || ''}`, 236, 932);

    if (url) {
      const sign = await imageLoader(url);

      ctx.drawImage(
        sign,
        sign.width > 1000 ? 290 : 290 + (1000 - sign.width) / 2,
        sign.height > 450 ? 1250 : 1250 + (450 - sign.height) / 2,
        sign.width > 1000 ? 1000 : sign.width,
        sign.height > 450 ? 450 : sign.height
      );
    }
  };

  const onhandleSubmit = async () => {
    if (!confirmJoin || !isSigned) {
      setFirstTime(true);
      return;
    }
    await draw();
    canvas.toBlob(async (blob) => {
      if (blob) {
        const file = new File([blob], 'confirm.jpeg');
        // setImg(URL.createObjectURL(file));
        const submitData = checkinMethod.getValues();
        handleSubmit({
          invitation_code: submitData.invitation_code || '',
          phone: submitData.phone,
          full_name: submitData.full_name,
          position_or_degree: submitData.position_or_degree,
          hospital: submitData.hospital,
          department: submitData.department,
          provinceCode: submitData.provinceCode?.value,
          dob: submitData.dob ? formatDDMMYYYY(submitData.dob) : undefined,
          signature: file,
        });
      }
    }, 'image/jpeg');
  };

  const handleClearSignature = () => {
    setIsSigned(false);
    signature?.clear();
    setUrl('');
  };

  const handleEndSignature = () => {
    setIsSigned(true);
    setUrl(signature?.getTrimmedCanvas().toDataURL('image/png') || '');
  };

  return (
    <div className="p-confirm">
      {/* <div className="p-confirm_conventionTitle">
        <div className="p-confirm_title">
          <Typography.Text
            fontweight="600"
          >
            Hội nghị:
            {' '}
            <span dangerouslySetInnerHTML={{ __html: general?.seminar || '' }} />
          </Typography.Text>
        </div>
        <Typography.Text
          extendClasses="fs-26x36"
          fontweight="600"
        >
          {`Thời gian: ${general?.seminarStartAt || ''}`}
        </Typography.Text>
        <Typography.Text
          extendClasses="fs-26x36"
          fontweight="600"
        >
          {`Địa điểm: ${general?.seminarIn || ''}`}
        </Typography.Text>
      </div> */}
      {/* <div className="p-confirm_userInfo">
        <Typography.Text
          extendClasses="fs-30x52"
          fontweight="600"
        >
          HỌ VÀ TÊN:
          {' '}
          {checkinMethod.getValues('full_name') || ''}
        </Typography.Text>
        <Typography.Text
          extendClasses="fs-30x52"
          fontweight="600"
        >
          BỆNH VIỆN:
          {' '}
          {checkinMethod.getValues('hospital') || ''}
        </Typography.Text>
        <Typography.Text
          extendClasses="fs-30x52"
          fontweight="600"
        >
          TỈNH THÀNH:
          {' '}
          {checkinMethod.getValues('provinceCode')?.label || ''}
        </Typography.Text>
      </div> */}
      <div className="p-confirm_conditionWrapper">
        <Typography.Text
          extendClasses="fs-30x52 u-mb-12 p-confirm_conditionWrapper_title"
          fontweight="600"
          textStyle="center"
        >
          Vui lòng ký xác nhận tham dự
          <br />
          hội thảo
        </Typography.Text>
        {/* <div className="p-confirm_conditionWrap">
          <div
            className="p-confirm_condition"
            onClick={() => setConfirmJoin(!confirmJoin)}
          >
            {confirmJoin && <Icon iconName="check" size="38" />}
          </div>
          <p
            onClick={() => setConfirmJoin(!confirmJoin)}
            className="p-confirm_termsText fs-26x36 color-antiFlashWhite"
          >
            Xác nhận tham dự hội nghị.
          </p>
        </div> */}
        {/* <div className="p-confirm_conditionWrap">
          <div
            className="p-confirm_condition"
            onClick={() => setConfirmJoin(!confirmJoin)}
          >
            {confirmJoin && <Icon iconName="check" size="38" />}
          </div>
          <p
            onClick={() => setConfirmJoin(!confirmJoin)}
            className="p-confirm_termsText fs-26x36 color-antiFlashWhite"
          >
            Tôi xác nhận việc nhận 1 chai Prosure Vanilla 220ml và 4 gói Prosure Vanilla 37.5G
            để phân phát cho bệnh nhân dùng thử. Tôi thừa nhận rằng tôi không bị ràng buộc sử dụng,
            mua, đặt mua, giới thiệu, hoặc kê đơn bất kỳ sản phẩm nào của Abbott, hoặc dành cho
            Abbott sự ưu đãi dưới hình thức khác.
          </p>
        </div> */}
        {!confirmJoin && firstTime && (
          <Typography.Text
            extendClasses="p-confirm_termsText-error fs-18x26 u-mt-8"
            fontweight="400"
          >
            Vui lòng xác nhận để tiếp tục
          </Typography.Text>
        )}
      </div>
      <div className="p-confirm_signatureWrapper">
        <SignatureCanvas
          canvasProps={{ className: 'sigCanvas' }}
          ref={(data: any) => setSignature(data)}
          onEnd={handleEndSignature}
        />
        <div
          className="p-confirm_clear"
          onClick={handleClearSignature}
        >
          <Icon iconName="clear" size="38" />
        </div>
        {!isSigned && firstTime && (
          <Typography.Text
            extendClasses="p-confirm_termsText-error fs-18x26 u-mt-8"
            fontweight="400"
            textStyle="center"
          >
            Vui lòng ký tên để tiếp tục
          </Typography.Text>
        )}
      </div>
      <div className="p-confirm_confirmButton_imgWrapper">
        <div
          className={mapModifiers('p-confirm_confirmButton', loading && 'loading')}
          onClick={() => {
            if (!loading) {
              handleClearSignature();
            }
          }}
        >
          <Image
            imgSrc={kyLai}
            alt="completeBtn"
            ratio={286 / 50}
            extendClasses="p-confirm_confirmButton_img"
          />
        </div>
        <div
          className={mapModifiers('p-confirm_confirmButton', loading && 'loading')}
          onClick={() => {
            if (!loading) {
              onhandleSubmit();
            }
          }}
        >
          {isCheckin && (
            <Typography.Text
              extendClasses="p-confirm_termsText-error p-confirm_termsText-checkin fs-26x36 u-mt-8"
              textStyle="center"
              fontweight="400"
            >
              Đã đăng ký tham dự chương trình
            </Typography.Text>
          )}
          <Image
            imgSrc={loading ? buttonEmpty : hoanthanh}
            alt="completeBtn"
            ratio={600 / 109}
            extendClasses="p-confirm_confirmButton_img"
          />
          {loading && (
            <Loading.Circle color="#0e3878" width={26} extendClasses="p-confirm_confirmButton_indicator" />
          )}
        </div>
      </div>
      {/* <img src={img} alt="preview" style={{ width: '100%', height: 'auto' }} /> */}
    </div >
  );
};

export default Confirm;
